<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'app',
  data () {
    return {
      locale: zhCN
    }
  }
}
</script>

<style>
.card {
  border-radius: 8px;
}
.font-15 {
  font-size: 15px;
}
.w-80p {
  width: 80px;
}
.color-red-del {
  color: #fe2a58;
}
.color-gray-cardtitle {
  color: #666a70;
}

.color-gray-card {
  color: #363b45;
}
.height-full {
  height: 100%;
}
.min-heiget-90{
  min-height: calc(100% - 100px);
}
.width-full{
  width: 100%;
}
.bg-w {
  background-color: white;
}
.unwrap {
  white-space: nowrap;
}
</style>
